import { clsx } from 'clsx';
import * as styles from './styles.css';
import { useDeviceType } from '@cian/ui-kit';

interface ISubTitleProps {
  text: string;
  theme?: 'white' | 'black';
}

export const SubTitle: React.FC<ISubTitleProps> = ({ text, theme = 'black' }) => {
  const device = useDeviceType();

  return <div className={clsx(styles['title'], styles[device], styles[theme])}>{text}</div>;
};
